export default function Home6() {
    return (
      <div className="min-h-screen bg-white">
        <div className="max-w-7xl mx-auto px-6 py-12 md:px-8 lg:px-12">
          {/* Header Section */}
          <div className="text-center mb-8">
            <h1 
              className="leading-tight mb-4"
              style={{
                fontFamily: '"Futura Bold", Sans-serif',
                fontSize: '100px',
                fontWeight: 700,
                lineHeight: '100px',
                color: '#0A476C'
              }}
            >
              Can I File an Uber
              <br />
              Sexual Assault Lawsuit?
            </h1>
            <div style={{ backgroundColor: '#FC821F' }} className="w-full max-w-2xl mx-auto h-2 bg-[#ffff00] rounded-sm"></div>
          </div>
  
          {/* Main Content */}
          <div className="space-y-6 leading-relaxed">
            <p 
              style={{
                fontSize: '21px',
                lineHeight: '35px',
                fontFamily: '"Avenir Book", sans-serif',
                fontWeight: 400,
                color: '#0A476C'
              }}
            >
              If you are a victim of sexual assault or abuse in an Uber, you have the option to file a lawsuit against the
              company and the perpetrator. This goes beyond reporting to the platform and reporting to law enforcement for
              criminal justice action. Filing a lawsuit can help prevent future harm and allow survivors to seek
              accountability, justice, and compensation.
            </p>
  
            <p 
              style={{
                fontSize: '21px',
                lineHeight: '35px',
                fontFamily: '"Avenir Book", sans-serif',
                fontWeight: 400,
                color: '#0A476C'
              }}
            >
              Individuals who have experienced harm in an Uber can:
            </p>
  
            {/* Bullet Points Section */}
            <div className="space-y-4 ml-4">
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-[#00bcd4] rounded-full mt-2 flex-shrink-0"></div>
                <p 
                  style={{
                    fontSize: '21px',
                    lineHeight: '35px',
                    fontFamily: '"Avenir Book", sans-serif',
                    fontWeight: 400,
                    color: '#0A476C'
                  }}
                >
                  <span 
                    style={{
                      fontFamily: '"Futura Bold", Sans-serif',
                      fontWeight: 700
                    }}
                  >
                    File a Lawsuit Against Uber
                  </span>{" "}
                  – You can sue Uber as a company for a failure to adequately
                  protect users from predatory drivers and riders.
                </p>
              </div>
  
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-[#00bcd4] rounded-full mt-2 flex-shrink-0"></div>
                <p 
                  style={{
                    fontSize: '21px',
                    lineHeight: '35px',
                    fontFamily: '"Avenir Book", sans-serif',
                    fontWeight: 400,
                    color: '#0A476C'
                  }}
                >
                  <span 
                    style={{
                      fontFamily: '"Futura Bold", Sans-serif',
                      fontWeight: 700
                    }}
                  >
                    File a Sexual Assault Lawsuit Against an Uber Driver
                  </span>{" "}
                  – You can also choose to sue the
                  driver individually for attempted or actual sexual assault that occurs during, or after an Uber trip.
                  Pursuing a civil case against the individual perpetrator is a separate action from any lawsuit against
                  Uber, and may not be necessary in some cases of harm.
                </p>
              </div>
            </div>
  
            <p 
              style={{
                fontSize: '21px',
                lineHeight: '35px',
                fontFamily: '"Avenir Book", sans-serif',
                fontWeight: 400,
                color: '#0A476C'
              }}
            >
              Most Uber sexual assault lawsuits are filed against the company for the following types of rideshare sexual
              abuse.
            </p>
  
            {/* Second Bullet Points Section */}
            <div className="space-y-3 ml-4">
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-[#00bcd4] rounded-full mt-2 flex-shrink-0"></div>
                <p 
                  style={{
                    fontSize: '21px',
                    lineHeight: '35px',
                    fontFamily: '"Avenir Book", sans-serif',
                    fontWeight: 400,
                    color: '#0A476C'
                  }}
                >
                  <a href="#" className="underline hover:no-underline">
                    Unwanted fondling or touching
                  </a>
                </p>
              </div>
  
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-[#00bcd4] rounded-full mt-2 flex-shrink-0"></div>
                <p 
                  style={{
                    fontSize: '21px',
                    lineHeight: '35px',
                    fontFamily: '"Avenir Book", sans-serif',
                    fontWeight: 400,
                    color: '#0A476C'
                  }}
                >
                  <a href="#" className="underline hover:no-underline">
                    Attempted rape
                  </a>
                </p>
              </div>
  
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-[#00bcd4] rounded-full mt-2 flex-shrink-0"></div>
                <p 
                  style={{
                    fontSize: '21px',
                    lineHeight: '35px',
                    fontFamily: '"Avenir Book", sans-serif',
                    fontWeight: 400,
                    color: '#0A476C'
                  }}
                >
                  Rape
                </p>
              </div>
  
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-[#00bcd4] rounded-full mt-2 flex-shrink-0"></div>
                <p 
                  style={{
                    fontSize: '21px',
                    lineHeight: '35px',
                    fontFamily: '"Avenir Book", sans-serif',
                    fontWeight: 400,
                    color: '#0A476C'
                  }}
                >
                  Other non-consensual sexual acts, such as kissing or oral sex
                </p>
              </div>
  
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-[#00bcd4] rounded-full mt-2 flex-shrink-0"></div>
                <p 
                  style={{
                    fontSize: '21px',
                    lineHeight: '35px',
                    fontFamily: '"Avenir Book", sans-serif',
                    fontWeight: 400,
                    color: '#0A476C'
                  }}
                >
                  Stalking and/or harassment
                </p>
              </div>
            </div>
  
            <p 
              style={{
                fontSize: '21px',
                lineHeight: '35px',
                fontFamily: '"Avenir Book", sans-serif',
                fontWeight: 400,
                color: '#0A476C'
              }}
            >
              If you were intoxicated, asleep, were under 18 at the time of the incident, or under the influence of drugs
              or other substances, your ability to consent to any sexual contact is impaired or limited. If you are having
              trouble remembering what happened, you can still seek assistance from us.
            </p>
  
            <p 
              style={{
                fontSize: '21px',
                lineHeight: '35px',
                fontFamily: '"Avenir Book", sans-serif',
                fontWeight: 400,
                color: '#0A476C'
              }}
            >
              The ability to file a sexual assault lawsuit against Uber or Lyft also depends on the civil statute of
              limitations in the state where the harm occurred. Even if you believe the statute of{" "}
              <a href="#" className="underline hover:no-underline">
                limitations for your case may have expired
              </a>
              , it's crucial to speak with an experienced Uber sexual assault lawyer to evaluate all your legal options.
            </p>
          </div>
        </div>
      </div>
    )
  }
  